import axios from 'axios'

export default {
    index() {
        return axios.get('/web-api/news')
    },
    show(slug) {
        return axios.get('/web-api/news/' + slug)
    }
}
